import clickOutside from '@/app/directives/click-outside'
import HomeLink from '@/components/elements/HomeLink.vue'
import TixMessage from '@/components/elements/TixMessage.vue'
import TixTemplate from '@/components/elements/TixTemplate.vue'
import SvgIcon from '@/components/icons/SvgIcon.vue'
import tenant from '@/helpers/Tenant'
import HelpersMixin from '@/plugins/HelpersMixin'
import PortalVue from 'portal-vue'
import Vue from 'vue'
import VueRouter from 'vue-router'
import Vuex from 'vuex'
import LoginLink from '../components/elements/LoginLink.vue'
import MembershipLink from '../components/elements/MembershipLink.vue'
import TenantContent from '../components/elements/TenantContent'
import Loader from '../components/Loader.vue'
import environment, { portal } from '../helpers/Environment'
import CurrencyFormatter from '../plugins/CurrencyFormatter'
import Modals from '../plugins/Modals'
import PageTitle from '../plugins/PageTitle'
import autofocus from './directives/autofocus'
import sameAs from './directives/same-as'
import scrollIntoView from './directives/scroll-into-view'
import autoParagraph from './filters/autoParagraph'
import router from './Router'
import VCalendar from 'v-calendar'

Vue.use(CurrencyFormatter)
Vue.use(Modals)
Vue.use(VueRouter)
Vue.use(Vuex)
Vue.use(PortalVue)
Vue.mixin(HelpersMixin)

Vue.component('Loader', Loader)
Vue.component('TenantContent', TenantContent)
Vue.component('HomeLink', HomeLink)
Vue.component('LoginLink', LoginLink)
Vue.component('MembershipLink', MembershipLink)
Vue.component('TixMessage', TixMessage)
Vue.component('SvgIcon', SvgIcon)
Vue.component('TixTemplate', TixTemplate)
// Renders an HTML comment node, which clears any slot fallback content.
// @see https://github.com/vuejs/vue/issues/7829
// @see https://codepen.io/sirlancelot/pen/oqxzMq?editors=1010
Vue.component('empty', { render: (h) => h() })

Vue.use(VCalendar, {
  screens: {
    lg: '1000px',
  },
})

// Automatically focus an element when it is inserted into the DOM.
Vue.directive('autofocus', autofocus)
Vue.directive('same-as', sameAs)
Vue.directive('scroll-into-viewport', scrollIntoView)

Vue.directive('click-outside', clickOutside)

// After creating router, activate plugins which take the router as an argument
Vue.use(PageTitle, router)

// TODO Use a filter instead.
Vue.prototype.autoP = autoParagraph

// Make config variables available in all templates.
Vue.prototype.$tenant = tenant
Vue.prototype.$portal = portal
Vue.prototype.$portalString = environment.portalStrings

export { Vue, router }
